import React from "react";
import { STEP_COLORS, STEP_LABEL } from "@/lib/stages";

export default function StageBadge({ step, cancelled = false, size = "md" }) {
  const key = cancelled ? "Cancelled" : (step || "New");
  const c = STEP_COLORS[key] || STEP_COLORS.New;
  const sizing = size === "sm"
    ? "text-[10px] px-2 py-0.5"
    : size === "lg"
      ? "text-sm px-3 py-1.5"
      : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid={`stage-badge-${key}`}
      className={`inline-flex items-center gap-1.5 font-mono font-semibold uppercase tracking-wider rounded-md border ${sizing}`}
      style={{ background: c.bg, color: c.text, borderColor: c.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c.text }} />
      {STEP_LABEL[key] || key}
    </span>
  );
}
